import { render, staticRenderFns } from "./IssueStatus.vue?vue&type=template&id=f09231f6"
import script from "./IssueStatus.vue?vue&type=script&lang=js"
export * from "./IssueStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports